module.exports = __webpack_public_path__ + "media/images/sidebar-arrow-3e0a6e8571a1b532e0359f08b1def1c8.svg";